import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_TattooTextGenerator = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/tattoo-text-generator',
			name: 'Tattoo Text Generator — AI Tattoo Maker from Text Online | Lift',
			description:
				'Generate custom tattoo text designs with AI in seconds. No watermark. Create script, lettering, and typography tattoos from text with our tattoo text generator. Try now!',
			url: 'https://liftapp.ai/tattoo-text-generator',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/tattoo-text-generator#product' },
				{ '@id': 'https://liftapp.ai/tattoo-text-generator#howto' },
				{ '@id': 'https://liftapp.ai/tattoo-text-generator#benefits' },
				{ '@id': 'https://liftapp.ai/tattoo-text-generator#faq' },
				{ '@id': 'https://liftapp.ai/tattoo-text-generator#why-lift' },
				{ '@id': 'https://liftapp.ai/tattoo-text-generator#explore-tools' },
				{ '@id': 'https://liftapp.ai/tattoo-text-generator#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/tattoo-text-generator#product',
			name: 'AI Tattoo Text Generator',
			description:
				"Create custom tattoo lettering and text designs with AI in seconds. Transform words into beautiful script, typography, and font styles. Try Lift's Tattoo Text Generator now!",
			url: 'https://liftapp.ai/tattoo-text-generator',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/tattoo-text-generator#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Choose your style & placement',
					text: 'Select from a range of tattoo styles and pick the exact body part where you want your tattoo',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Describe your vision',
					text: 'Write your tattoo idea in detail or keep it simple — our AI tattoo text generator understands your concept',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Add reference images',
					text: 'Upload reference photos for inspiration, and let our AI tattoo text generator bring your vision to life.',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download your design',
					text: 'Get your AI generated tattoo instantly — ready to show your tattoo artist or save for later',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/tattoo-text-generator#benefits',
			name: 'Who can benefit from AI Tattoo Text Generator?',
			description:
				"Lift's AI Tattoo Text Generator helps first-time clients, creative individuals, and anyone looking to visualize tattoo text designs before committing.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'First-time tattoo clients — Unsure about committing to your first design? Our AI tattoo text generator helps you visualize tattoo ideas on your body before booking, reducing fear of regret and making the process stress-free.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Tattoo lovers seeking unique lettering — Tired of generic designs online? Use Lift as a tattoo text generator to create original tattoo lettering and meaningful styles that match your personality.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'AI tattoo text generator for clear visual references — Struggling to describe your tattoo vision? The tattoo text creator turns your words and references into clear AI-generated tattoo previews instantly.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Users exploring placement and style options — Not sure what looks best on your arm, back, or leg? Our tattoo text generator helps you test styles and placements until it feels perfect.',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Creative explorers & custom script seekers — Want elegant lettering or bold typography? Try a tattoo text style generator to experiment with custom fonts and fancy tattoo text styles for a truly personal design.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Best Tattoo Text Generator for Custom Tattoo Lettering',
				description:
					'Tattoo text generator showing custom script design previewed on wrist.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/tattoo-text-generator#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift Tattoo Text Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift Tattoo Text Generator is a online tool that instantly creates custom tattoo lettering, script, and typography designs using artificial intelligence — perfect for visualizing text-based tattoos, creating unique fonts, and personalizing word designs before your appointment.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift Tattoo Text Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Simply choose your preferred tattoo text style (script, lettering, typography), describe your text or concept, and optionally upload reference photos. Our AI tattoo generator from text processes your input and creates unique, personalized tattoo text designs in seconds — no design skills required.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I customize the tattoo designs generated by AI?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Absolutely! You can generate multiple text variations by adjusting your prompt, trying different lettering styles, or exploring various script fonts. The tattoo text creator gives you full creative control to experiment with typography, cursive, calligraphy, and custom fonts until you find your perfect design.',
					},
				},
				{
					'@type': 'Question',
					name: 'What text and lettering styles can I create with the tattoo text generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift supports all popular text styles including script tattoos, cursive lettering, calligraphy, gothic fonts, minimalist typography, traditional lettering, monograms, and ambigrams. Our tattoo typography generator is perfect for names, quotes, dates, symbols, and any custom text-based tattoo concept.',
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/tattoo-text-generator#why-lift',
			name: "Why Lift's Tattoo Text Generator stands out",
			description:
				"Lift's Tattoo Text Generator combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'AI Tattoo text generator showing custom script design previewed on neck',
				description:
					"Comparison of Lift's Tattoo Text Generator benefits — professional quality, AI accuracy, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/tattoo-text-generator#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/tattoo-text-generator#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Tattoo Text Generator',
					item: 'https://liftapp.ai/tattoo-text-generator',
				},
			],
		},
	],
};
